import M_ENV from './../env/index.js'

let Hook = {
    /**
     * 绑定至全局对象
     * 不判断是否已存在LXDataReport，直接覆盖全局对象，以后调用的为主
     * @param {Instance} dataObj 数据上报实例
     */
    hookToGlobal (dataObj){
        if (dataObj) {
            let lx_report_global = null

            // 挂载进全局作用域
            // 如果存在weex环境
            if (M_ENV.isWeex) {
                lx_report_global = weex
            } else {
                // 一期仅支持H5和weex
                lx_report_global = window
            }
            (function (exports) {
                // 完全没有注册过，直接注册全局实例
                if (typeof exports.LXDataReport === 'undefined') {
                    exports.LXDataReport = dataObj
                }
            })(lx_report_global)
        }
    }
}

export default Hook